import dayjs from 'dayjs';

const numberFormat = function (strNumber) {
    strNumber = strNumber.toString().trim();
    if (!strNumber.length) return "";
    if (strNumber === "-") return "-"

    let sign = "";
    let decimal = "";
    let numberArray = strNumber.replace(/[^0-9,.]/g, "").replace(/[,]/g, ".").split(".");

    if (strNumber.charAt(0) === "-") {
        sign = "-";
    }

    if (numberArray.length > 1) {
        decimal = "." + numberArray.pop();
    }
    return sign + numberArray.join(numberArray) + decimal;
}

const zfill = function (strNumber, precision = 2) {
    if (strNumber === '') return '';
    return parseFloat(strNumber.toString()).toFixed(precision);
}

const humanFileSize = function (bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(dp) + ' ' + units[u];
}

const lightenDarkenColor = function (color, percent) {
    var num = parseInt(color.replace("#", ""), 16),
        amt = Math.round(2.55 * percent),
        R = (num >> 16) + amt,
        B = (num >> 8 & 0x00FF) + amt,
        G = (num & 0x0000FF) + amt;
    return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
}



const getDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    // return `${year}-${month}`;
    // return [year, month ].join('-');
    return [year, month]

}
const formatDateTime = function(dateTime) {
    return dayjs(dateTime).format('YYYY-MM-DD HH:mm');
}

const formatDateOnly = function(dateTime) {
    return dayjs(dateTime).format('YYYY-MM-DD');
}



const randomColor = () => {
    let color = '#';
    for (let i = 0; i < 6; i++) {
        const random = Math.random();
        const bit = (random * 16) | 0;
        color += (bit).toString(16);
    }
    return color;
}
const setProjectsCollors = (color) => {
    if (color) {
        return (
            "--project-color:" +
            color +
            "; --project-color-darken:" +
            lightenDarkenColor("#" + color.substring(1), -40)
        );
    }
    return false;
}
const dateFormat = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('default').format(date);
}
export {
    setProjectsCollors,
    randomColor,
    humanFileSize,
    numberFormat,
    lightenDarkenColor,
    zfill,
    dateFormat,
    getDate,
    formatDateTime,
    formatDateOnly

}
